import React from 'react';
import PropTypes, { any } from 'prop-types';

import Filter, { FilterModal, FilterSection } from '../../../SearchPage/Filters/Filter';
import CheckboxFilter from '../../../SearchPage/Filters/FilterComponents/CoreComponents/CheckboxFilter';

import styles from '../../../SearchPage/search.scss';
import { gameTypeValues } from '../../../../utils/eventConstants';

const DivisionDateFilter = (props) => {
    const { filters, filterModal, handleFilterClick, closeModals, filterInputs, handleFilterSubmit, handleFilterUpdate, mobileOnly, desktopOnly, filteredDivisions = [], 'data-testid': dataTestId } = props;

    const compareDateStrings = (a, b) => {
        if (a.specificDivisionDateUtc < b.specificDivisionDateUtc) {
            return -1;
        }
        if (a.specificDivisionDateUtc > b.specificDivisionDateUtc) {
            return 1;
        }
        return 0;
    };

    const formatDateString = (utcDate) => {
        const d = new Date(utcDate);
        return d.toLocaleDateString();
    };

    const dateDictionary = {};
    filteredDivisions.forEach(div => {
        if (div.specificDivisionDateEnabled) {
            dateDictionary[div.specificDivisionDateUtc] = dateDictionary[div.specificDivisionDateUtc] ? dateDictionary[div.specificDivisionDateUtc] + 1 : 1;
        }
    });

    const seen = new Set();
    const options = filteredDivisions
        .sort(compareDateStrings)
        .filter(div => div.specificDivisionDateEnabled)
        .filter(div => {
            if (filters.selectedDivs.length) {
                return filters.selectedDivs.includes(div.id);
            }
            return true;
        })
        .filter(div => {
            // remove duplicates
            if (seen.has(div.specificDivisionDateUtc)) {
                return false;
            }
            seen.add(div.specificDivisionDateUtc);
            return true;
        })
        .map(div => ({ label: `${formatDateString(div.specificDivisionDateUtc)} (${dateDictionary[div.specificDivisionDateUtc]})`, value: div.specificDivisionDateUtc }));

    const addOrRemoveId = (utcDate) => {
        let updated;
        if (filterInputs.selectedDates.includes(utcDate)) {
            updated = filterInputs.selectedDates.filter(item => item !== utcDate);
        } else {
            updated = [...filterInputs.selectedDates, utcDate];
        }
        return updated;
    };

    const filterName = 'selectedDates';

    return options.length ? (
        <div className={styles.filterWrapper}>
            <Filter
                filterName={filterName}
                handleFilterClick={handleFilterClick}
                isActive={!!filters?.selectedDates?.length || filterModal === filterName}
                mobileOnly={mobileOnly}
                desktopOnly={desktopOnly}
                data-testid={dataTestId}
            >
                Date
            </Filter>
            {filterModal === filterName && (
                <FilterModal
                    title={'Selected Dates'}
                    handleFilterSubmit={handleFilterSubmit}
                    onCloseClick={closeModals}
                    data-testid={dataTestId}
                >
                    <FilterSection>
                        <CheckboxFilter
                            options={options}
                            filterInputs={filterInputs}
                            filterInputName={filterName}
                            data-testid={dataTestId && `${dataTestId}.options`}
                            onChange={(value) => {
                                handleFilterUpdate({
                                    selectedDates: addOrRemoveId(value),
                                });
                            }}
                            isArray
                        />
                    </FilterSection>
                </FilterModal>
            )}
        </div>
    ) : null;
};

DivisionDateFilter.propTypes = {
    filters: PropTypes.objectOf(any).isRequired,
    filterModal: PropTypes.objectOf(any).isRequired,
    handleFilterClick: PropTypes.func.isRequired,
    closeModals: PropTypes.func.isRequired,
    filterInputs: PropTypes.objectOf(any).isRequired,
    handleFilterUpdate: PropTypes.func.isRequired,
    handleFilterSubmit: PropTypes.func.isRequired,
    mobileOnly: PropTypes.bool,
    desktopOnly: PropTypes.bool,
    filteredDivisions: PropTypes.arrayOf(any),
    'data-testid': PropTypes.string,
};

DivisionDateFilter.defaultProps = {
    mobileOnly: false,
    desktopOnly: false,
    filteredDivisions: [],
    'data-testid': undefined,
};

export default DivisionDateFilter;
